import { render } from "./RIList.vue?vue&type=template&id=60fd98c1&scoped=true"
import script from "./RIList.vue?vue&type=script&lang=js"
export * from "./RIList.vue?vue&type=script&lang=js"

import "./RIList.vue?vue&type=style&index=0&id=60fd98c1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fd98c1"]])

export default __exports__